import { get } from '.';

export const getLanguages = () => {
  return get(`/api/v1/languages`);
};
